export enum FilterTypes {
  OPEN_FILTER_PANEL = 'ui/filters/OPEN_FILTER_PANEL',
  CLOSE_FILTER_PANEL = 'ui/filters/CLOSE_FILTER_PANEL',
  SET_TARGET = 'ui/filters/SET_TARGET',
  ADD_FILTER = 'ui/filters/ADD_FILTER',
  REMOVE_FILTER = 'ui/filters/REMOVE_FILTER',
}
